import * as React from "react";

export interface TextColorIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export const TextColorIcon = React.forwardRef<SVGSVGElement, TextColorIconProps>(({ size = 24, ...props }, ref) => (
  <svg
    ref={ref}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    aria-hidden="true"
    focusable="false"
  >
    <path d="M5 18h14v3H5zm7.5-14h-1c-.401 0-.764.24-.921.609L5.745 16h2.173l1.273-3h5.604l1.268 3h2.171L13.421 4.61A1 1 0 0 0 12.5 4zm-2.46 7 1.959-4.616L13.95 11h-3.91z" />
  </svg>
));

TextColorIcon.displayName = "TextColorIcon";

export default TextColorIcon;
